// extracted by css-extract-rspack-plugin
export default {"footer":"rshim","links":"WBzio","copyright_override":"Y8D5A","copyrightOverride":"Y8D5A","#":"aW3lp"};